//import libs
import ErrorBoundary from 'common/ui/misc/ErrorBoundary';
import PageLoading from 'common/ui/misc/PageLoading';
import PropTypes from 'prop-types';
import WebPushSubscriber from '../modules/notifications/web-push/components/WebPushSubscriber';
import WebSocketSubscriber from '../modules/notifications/web-socket/components/WebSocketSubscriber';
import useConfig from '../utils/hooks/useConfig';
import Header from './blocks/header';
import NavBar from './blocks/navbar';

const displayName = 'Private Layout';
const propTypes = {
    children: PropTypes.node.isRequired,
};

const PrivateLayout = ({ children, user }) => {
    const config = useConfig();
    const showLicense =
        config.remote?.license?.warning !== '' &&
        config.remote?.license?.warning !== undefined &&
        config.remote?.license?.warning !== null;
    return (
        <>
            <NavBar config={config} />
            <Header />
            <div className="pcoded-main-container">
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <WebPushSubscriber />
                            <WebSocketSubscriber />
                            <ErrorBoundary>
                                {showLicense && (
                                    <div className="card">
                                        <div className="card-block p-2">
                                            <div className="row">
                                                <div className="col-sm-12 text-danger">
                                                    {config.remote?.license?.warning}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {user ? children : <PageLoading />}
                            </ErrorBoundary>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

PrivateLayout.displayName = displayName;
PrivateLayout.propTypes = propTypes;

export default PrivateLayout;
